module.exports = __webpack_public_path__ + "static/img/pic.27320a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/pic.png
// module id = HBvN
// module chunks = 1